import { AboutContentViewModel, DealerLedgerViewModel } from "@lumora/core";
import { SITE, client } from "../client.js";
import type { AboutData } from "../models/About.js";

/** Shipped about copy, served from the site's static assets. */
export async function loadMigratedAbout(): Promise<AboutData> {
  for (const href of ["/migrated-about.json", "./migrated-about.json", "migrated-about.json"]) {
    const res = await fetch(href);
    if (res.ok) return (await res.json()) as AboutData;
  }
  return {} as AboutData;
}

/** About / disclaimer copy: saved JSON when signed in, else the shipped file. */
export const aboutContent = new AboutContentViewModel<AboutData>(client, SITE, {
  fallback: loadMigratedAbout,
  mirrorFields: (data) => ({
    phone: data.contact?.phoneSales?.value ?? "",
    address: data.footer?.address?.value ?? data.contact?.addressLine1?.value ?? "",
  }),
});

/** Year-to-date numbers for the staff command center. */
export const businessSummary = new DealerLedgerViewModel(client);
